import React from "react";
import { motion } from "framer-motion";
import "../App.css";

const skillCategories = {
  "Frontend Development": [
    "Next.js",
    "React.js",
    "Tailwind CSS",
    "JavaScript (ES6+)",
    "TypeScript",
    "HTML5 & CSS3",
    "Bootstrap"
  ],

  "Backend Development": [
    "Node.js",
    "Express.js",
    "Java",
    "Spring Boot",
    "JSP & Servlets",
    "Python (Basics)"
  ],

  "Databases": [
    "MongoDB",
    "MySQL",
    "PostgreSQL (Basics)"
  ],

  "AI & Automation": [
    "Google Gemini AI",
    "PlayWright (Web Scraping)",
    "OpenCV (Basics)"
  ],

  "Cloud & DevOps": [
    "AWS (EC2, S3)",
    "Google Cloud Platform (GCP)",
    "Docker",
    "CI/CD Fundamentals",
    "GitHub Actions",
    "Jenkins"
  ],

  "Tools & Version Control": [
    "Git",
    "GitHub",
    "Postman",
    "VS Code",
    "Linux (Ubuntu)"
  ]
};

export default function Skills() {
  return (
    <div>
      <h2 className="section-title text-center mb-5">Technical Expertise</h2>

      <div className="row g-4">
        {Object.entries(skillCategories).map(([category, skills], index) => (
          <div key={index} className="col-md-4">
            <div className="h-100 p-3">
              <h5 className="text-accent small text-uppercase mb-4 fw-bold tracking-widest">{category}</h5>
              <div className="d-flex flex-wrap gap-2">
                {skills.map((skill, i) => (
                  <div key={i} className="skill-badge">
                    {skill}
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
